// Module
var code = `<template> <check-box checked.two-way="meta.setWorkflowAsCompletedIfAllRulesPassed" value="Set Workflow As Completed if all rules passed"></check-box> </template>`;
// Exports
module.exports = code;